__turbopack_context__.v({
  "facebook": "SocialLink-module-scss-module__EDznFG__facebook",
  "fade-in": "SocialLink-module-scss-module__EDznFG__fade-in",
  "instagram": "SocialLink-module-scss-module__EDznFG__instagram",
  "pinterest": "SocialLink-module-scss-module__EDznFG__pinterest",
  "root": "SocialLink-module-scss-module__EDznFG__root",
  "tiktok": "SocialLink-module-scss-module__EDznFG__tiktok",
  "youtube": "SocialLink-module-scss-module__EDznFG__youtube",
});
